"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resetPanViewNexi = exports.copyPanViewNexi = exports.copyPanViewNexiSuccess = exports.getPanViewNexi = exports.startPanViewScaNexi = exports.resetPinViewNexiCredit = exports.getPinViewNexiCredit = exports.startPinViewScaNexiCredit = exports.resetNexi = exports.resetFiltriNexi = exports.esportaMovimentiNexiExcel = exports.esportaDettaglioMovimentoNexiPDF = exports.callNexiServlet = exports.callNexiServletReset = exports.resetTokenSsoNexi = exports.getMovimentiNexi = exports.getParametriNexi = exports.verificaConsensoNexi = exports.variaConsensoNexi = exports.getTokenSSONexi = exports.setRapportoSelezionatoNexi = exports.setNexiSetOrdinamento = exports.setNexiSetOffset = exports.setNexiSetEsercente = exports.setNexiSetImporto = exports.setNexiSetPeriodo = exports.setNexiSetDataDa = exports.setNexiSetDataA = void 0;
const api_rest_1 = require("@sparkasse/api-rest");
const __1 = require("..");
const general_actions_1 = require("../general/general.actions");
const general_configuration_1 = require("../general/general.configuration");
const helpers_1 = require("../helpers");
const moment = require("moment");
function setNexiSetDataA(txt) {
    return {
        type: __1.EReduxActionTypes.NEXI_DATA_A,
        payload: txt
    };
}
exports.setNexiSetDataA = setNexiSetDataA;
function setNexiSetDataDa(txt) {
    return {
        type: __1.EReduxActionTypes.NEXI_DATA_DA,
        payload: txt
    };
}
exports.setNexiSetDataDa = setNexiSetDataDa;
function setNexiSetPeriodo(txt) {
    return {
        type: __1.EReduxActionTypes.NEXI_PERIODO,
        payload: txt
    };
}
exports.setNexiSetPeriodo = setNexiSetPeriodo;
function setNexiSetImporto(num) {
    return {
        type: __1.EReduxActionTypes.NEXI_IMPORTO,
        payload: num
    };
}
exports.setNexiSetImporto = setNexiSetImporto;
function setNexiSetEsercente(txt) {
    return {
        type: __1.EReduxActionTypes.NEXI_ESERCENTE,
        payload: txt
    };
}
exports.setNexiSetEsercente = setNexiSetEsercente;
function setNexiSetOffset(offset) {
    return {
        type: __1.EReduxActionTypes.NEXI_OFFSET,
        payload: offset
    };
}
exports.setNexiSetOffset = setNexiSetOffset;
function setNexiSetOrdinamento(val) {
    return {
        type: __1.EReduxActionTypes.NEXI_ORDINAMENTO,
        payload: val
    };
}
exports.setNexiSetOrdinamento = setNexiSetOrdinamento;
/* get token SSO - START */
function getTokenSSONexiStart() {
    return {
        type: __1.EReduxActionTypes.NEXI_GET_TOKEN_SSO_START
    };
}
;
function getTokenSSONexiSuccess(payload) {
    return {
        type: __1.EReduxActionTypes.NEXI_GET_TOKEN_SSO_SUCCESS,
        payload
    };
}
;
function generalError(value) {
    return async (dispatch) => {
        dispatch((0, general_actions_1.setError)(value));
    };
}
;
const setRapportoSelezionatoNexi = (rapporto) => {
    return {
        type: __1.EReduxActionTypes.NEXI_SET_RAPPORTO_SELEZIONATO,
        payload: rapporto
    };
};
exports.setRapportoSelezionatoNexi = setRapportoSelezionatoNexi;
const getTokenSSONexi = () => async (dispatch, _, extraArguments) => {
    dispatch((0, general_actions_1.setLoader)(true));
    dispatch(getTokenSSONexiStart());
    if (extraArguments.mock) {
        Promise.resolve().then(() => require('../../mock/parametri_movimenti.json')).then(parametri => {
            dispatch(getTokenSSONexiSuccess((0, api_rest_1.CartaSiSSoDtoFromJSON)({})));
            dispatch((0, general_actions_1.setLoader)(false));
        });
    }
    else {
        extraArguments.getItem('jwt').then((jwt) => {
            new api_rest_1.NexiControllerApi((0, general_configuration_1.default)(api_rest_1.Configuration, extraArguments, undefined, jwt)).tokenSSONexi().then((response) => {
                dispatch(getTokenSSONexiSuccess(response));
            }).catch(async (error) => {
                dispatch(generalError(await (0, helpers_1.formatError)(error)));
            }).finally(() => {
                dispatch((0, general_actions_1.setLoader)(false));
            });
        });
    }
};
exports.getTokenSSONexi = getTokenSSONexi;
/* get token SSO - FINE */
/* varia consenso - START */
function variaConsensoNexiStart() {
    return {
        type: __1.EReduxActionTypes.NEXI_VARIA_CONSENSO_START
    };
}
;
function variaConsensoNexiSuccess(payload) {
    return {
        type: __1.EReduxActionTypes.NEXI_VARIA_CONSENSO_SUCCESS,
        payload
    };
}
;
const variaConsensoNexi = () => async (dispatch, _, extraArguments) => {
    dispatch((0, general_actions_1.setLoader)(true));
    dispatch(variaConsensoNexiStart());
    if (extraArguments.mock) {
        Promise.resolve().then(() => require('../../mock/parametri_consenso.json')).then(parametri => {
            dispatch(variaConsensoNexiSuccess((0, api_rest_1.ConsensoNexiDtoFromJSON)(parametri)));
            dispatch((0, general_actions_1.setLoader)(false));
        });
    }
    else {
        const requestParameters = {
            codiceConsenso: "C6",
            variazioneNexiRequestDto: {
                value: "S"
            }
        };
        extraArguments.getItem('jwt').then((jwt) => {
            new api_rest_1.NexiControllerApi((0, general_configuration_1.default)(api_rest_1.Configuration, extraArguments, undefined, jwt)).variaConsensoNexi(requestParameters).then((response) => {
                dispatch(verificaConsensoNexiSuccess(response));
            }).catch(async (error) => {
                dispatch(generalError(await (0, helpers_1.formatError)(error)));
            }).finally(() => {
                dispatch((0, general_actions_1.setLoader)(false));
            });
        });
    }
};
exports.variaConsensoNexi = variaConsensoNexi;
/* varia consenso - FINE */
/* verifica consenso - START */
function verificaConsensoNexiStart() {
    return {
        type: __1.EReduxActionTypes.NEXI_VERIFICA_CONSENSO_START
    };
}
;
function verificaConsensoNexiSuccess(payload) {
    return {
        type: __1.EReduxActionTypes.NEXI_VERIFICA_CONSENSO_SUCCESS,
        payload
    };
}
;
const verificaConsensoNexi = () => async (dispatch, _, extraArguments) => {
    dispatch((0, general_actions_1.setLoader)(true));
    dispatch(verificaConsensoNexiStart());
    if (extraArguments.mock) {
        Promise.resolve().then(() => require('../../mock/parametri_consenso.json')).then(parametri => {
            dispatch(verificaConsensoNexiSuccess((0, api_rest_1.ConsensoNexiDtoFromJSON)(parametri)));
            dispatch((0, general_actions_1.setLoader)(false));
        });
    }
    else {
        const requestParameters = {
            codiceConsenso: "C6"
        };
        extraArguments.getItem('jwt').then((jwt) => {
            new api_rest_1.NexiControllerApi((0, general_configuration_1.default)(api_rest_1.Configuration, extraArguments, undefined, jwt)).verificaConsensoNexi(requestParameters).then((response) => {
                dispatch(verificaConsensoNexiSuccess(response));
            }).catch(async (error) => {
                dispatch(generalError(await (0, helpers_1.formatError)(error)));
            }).finally(() => {
                dispatch((0, general_actions_1.setLoader)(false));
            });
        });
    }
};
exports.verificaConsensoNexi = verificaConsensoNexi;
/* verifica consenso - FINE */
/* verifica consenso - START */
function getParametriNexiStart() {
    return {
        type: __1.EReduxActionTypes.NEXI_GET_PARAMETRI_START
    };
}
;
function getParametriNexiSuccess(payload) {
    return {
        type: __1.EReduxActionTypes.NEXI_GET_PARAMETRI_SUCCESS,
        payload
    };
}
;
const getParametriNexi = () => async (dispatch, _, extraArguments) => {
    dispatch((0, general_actions_1.setLoader)(true));
    dispatch(getParametriNexiStart());
    if (extraArguments.mock) {
        Promise.resolve().then(() => require('../../mock/parametri_nexi.json')).then(response => {
            dispatch(getParametriNexiSuccess((0, api_rest_1.ParametriNexiDtoFromJSON)(response)));
            dispatch((0, general_actions_1.setLoader)(false));
        });
    }
    else {
        extraArguments.getItem('jwt').then((jwt) => {
            new api_rest_1.NexiControllerApi((0, general_configuration_1.default)(api_rest_1.Configuration, extraArguments, undefined, jwt)).parametriNexi().then((response) => {
                var _a;
                dispatch(getParametriNexiSuccess(response));
                !!(response === null || response === void 0 ? void 0 : response.rapporti) && dispatch((0, exports.setRapportoSelezionatoNexi)((_a = response === null || response === void 0 ? void 0 : response.rapporti) === null || _a === void 0 ? void 0 : _a[0]));
            }).catch(async (error) => {
                dispatch(generalError(await (0, helpers_1.formatError)(error)));
            }).finally(() => {
                dispatch((0, general_actions_1.setLoader)(false));
            });
        });
    }
};
exports.getParametriNexi = getParametriNexi;
function getMovimentiNexiStart() {
    return {
        type: __1.EReduxActionTypes.NEXI_GET_MOVIMENTI_START
    };
}
;
function getMovimentiNexiSuccess(payload) {
    return {
        type: __1.EReduxActionTypes.NEXI_GET_MOVIMENTI_SUCCESS,
        payload
    };
}
;
const IMPORTO_MOLTIPLICATORI_INTERVALLO = { MIN: 0.8, MAX: 1.2 };
const getMovimentiNexi = () => async (dispatch, getState, extraArguments) => {
    var _a, _b, _c, _d, _e, _f;
    dispatch((0, general_actions_1.setLoader)(true));
    dispatch(getMovimentiNexiStart());
    if (extraArguments.mock) {
        Promise.resolve().then(() => require('../../mock/nexiListaMovimentiCarta.json')).then(response => {
            dispatch(getMovimentiNexiSuccess((0, api_rest_1.ListaMovimentiNexiDtoFromJSON)(response)));
            dispatch((0, general_actions_1.setLoader)(false));
        });
    }
    else {
        const nexiForm = getState().nexi.form;
        const requestParameters = {
            movimentiCartaRequestDto: {
                intestatario: (_b = (_a = nexiForm.rapportoSelezionato) === null || _a === void 0 ? void 0 : _a.carta) === null || _b === void 0 ? void 0 : _b.intestazione,
                panAlias: (_f = (_e = (_d = (_c = nexiForm.rapportoSelezionato) === null || _c === void 0 ? void 0 : _c.carta) === null || _d === void 0 ? void 0 : _d.id) === null || _e === void 0 ? void 0 : _e.value) !== null && _f !== void 0 ? _f : '-',
                dataIniziale: moment(nexiForm.dataDa).toDate(),
                dataFinale: moment(nexiForm.dataA).toDate(),
                importoDa: (0, helpers_1.formattedNumberToNumber)(nexiForm.importo) * IMPORTO_MOLTIPLICATORI_INTERVALLO.MIN || undefined,
                importoA: (0, helpers_1.formattedNumberToNumber)(nexiForm.importo) * IMPORTO_MOLTIPLICATORI_INTERVALLO.MAX || undefined,
                ordinamento: api_rest_1.MovimentiCartaRequestDtoOrdinamentoEnum.D,
                divisa: undefined,
                offset: nexiForm.offset,
                keyword: nexiForm.esercente,
                idPeriodo: nexiForm.periodo
            }
        };
        extraArguments.getItem('jwt').then((jwt) => {
            new api_rest_1.NexiControllerApi((0, general_configuration_1.default)(api_rest_1.Configuration, extraArguments, undefined, jwt)).recuperaMovimentiCarta(requestParameters).then((response) => {
                dispatch(getMovimentiNexiSuccess(response));
            }).catch(async (error) => {
                dispatch(generalError(await (0, helpers_1.formatError)(error)));
            }).finally(() => {
                dispatch((0, general_actions_1.setLoader)(false));
            });
        });
    }
};
exports.getMovimentiNexi = getMovimentiNexi;
/* verifica consenso - FINE */
function resetTokenSsoNexi() {
    return {
        type: __1.EReduxActionTypes.NEXI_RESET_TOKEN_SSO
    };
}
exports.resetTokenSsoNexi = resetTokenSsoNexi;
;
/* callNexiServlet */
function callNexiServletStart() {
    return {
        type: __1.EReduxActionTypes.NEXI_CALL_SERVLET_START
    };
}
;
function callNexiServletReset() {
    return {
        type: __1.EReduxActionTypes.NEXI_CALL_SERVLET_RESET
    };
}
exports.callNexiServletReset = callNexiServletReset;
;
function callNexiServletSuccess(payload) {
    return {
        type: __1.EReduxActionTypes.NEXI_CALL_SERVLET_SUCCESS,
        payload
    };
}
;
const callNexiServlet = () => async (dispatch, _, extraArguments) => {
    dispatch((0, general_actions_1.setLoader)(true));
    dispatch(callNexiServletStart());
    if (extraArguments.mock) {
        dispatch((0, general_actions_1.setLoader)(false));
    }
    else {
        extraArguments.getItem('jwt').then((jwt) => {
            new api_rest_1.NexiControllerApi((0, general_configuration_1.default)(api_rest_1.Configuration, extraArguments, undefined, jwt)).callNexiServlet().then((response) => {
                dispatch(callNexiServletSuccess(response));
            }).catch(async (error) => {
                dispatch(generalError(await (0, helpers_1.formatError)(error)));
            }).finally(() => {
                dispatch((0, general_actions_1.setLoader)(false));
            });
        });
    }
};
exports.callNexiServlet = callNexiServlet;
/* esporta PDF dettaglio movimento - START */
function esportaDettaglioMovimentoNexiPDFStart() {
    return {
        type: __1.EReduxActionTypes.NEXI_ESPORTA_DETTAGLIO_PDF_START
    };
}
function esportaDettaglioMovimentoNexiPDFSuccess(payload) {
    return {
        type: __1.EReduxActionTypes.NEXI_ESPORTA_DETTAGLIO_PDF_SUCCESS,
        payload
    };
}
const esportaDettaglioMovimentoNexiPDF = (movimento) => async (dispatch, getState, extraArguments) => {
    var _a;
    dispatch((0, general_actions_1.setLoader)(true));
    dispatch((0, general_actions_1.setWaitingSection)(true, `PDF${movimento.movimentoId}`));
    dispatch(esportaDettaglioMovimentoNexiPDFStart());
    if (extraArguments.mock) {
        dispatch((0, general_actions_1.setLoader)(false));
    }
    else {
        const dettaglioMovimentoNexiPdfRequest = {
            exportMovimentoCartaRequestDto: {
                cartaDto: (_a = getState().nexi.form.rapportoSelezionato) === null || _a === void 0 ? void 0 : _a.carta,
                movimentoDto: movimento
            }
        };
        extraArguments.getItem('jwt').then((jwt) => {
            new api_rest_1.NexiControllerApi((0, general_configuration_1.default)(api_rest_1.Configuration, extraArguments, undefined, jwt, 'application/pdf')).dettaglioMovimentoNexiPdf(dettaglioMovimentoNexiPdfRequest).then(async (response) => {
                if (extraArguments.platform === 'desktop') {
                    (0, helpers_1.hadlePdfResponse)(response, (url) => dispatch((0, general_actions_1.popUpBlockedPdf)(url)));
                }
                if (extraArguments.platform === 'mobile') {
                    (0, helpers_1.download_sharePDF)(extraArguments, `movimento-${movimento.movimentoId}.pdf`, response);
                }
                dispatch(esportaDettaglioMovimentoNexiPDFSuccess(response));
            }).catch(async (error) => {
                try {
                    dispatch(generalError(await (0, helpers_1.formatError)(error)));
                }
                catch (e) {
                    console.log(e);
                }
            }).finally(() => {
                dispatch((0, general_actions_1.setLoader)(false));
                dispatch((0, general_actions_1.setWaitingSection)(false, `PDF${movimento.movimentoId}`));
            });
        });
    }
};
exports.esportaDettaglioMovimentoNexiPDF = esportaDettaglioMovimentoNexiPDF;
function esportaNexiExcelStart() {
    return {
        type: __1.EReduxActionTypes.NEXI_ESPORTA_EXCEL_START
    };
}
function esportaNexiExcelSuccess(payload) {
    return {
        type: __1.EReduxActionTypes.NEXI_ESPORTA_EXCEL_SUCCESS,
        payload
    };
}
const esportaMovimentiNexiExcel = () => async (dispatch, getState, extraArguments) => {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    dispatch(esportaNexiExcelStart());
    dispatch((0, general_actions_1.setLoader)(true));
    if (extraArguments.mock) {
        dispatch((0, general_actions_1.setLoader)(false));
    }
    else {
        const stateNexi = getState().nexi;
        const nexiForm = stateNexi.form;
        const elencoMovimentiNexiExcelRequest = {
            movimentiCartaRequestDto: {
                intestatario: (_b = (_a = nexiForm.rapportoSelezionato) === null || _a === void 0 ? void 0 : _a.carta) === null || _b === void 0 ? void 0 : _b.intestazione,
                panAlias: (_f = (_e = (_d = (_c = nexiForm.rapportoSelezionato) === null || _c === void 0 ? void 0 : _c.carta) === null || _d === void 0 ? void 0 : _d.id) === null || _e === void 0 ? void 0 : _e.value) !== null && _f !== void 0 ? _f : '-',
                pan: (_h = (_g = nexiForm.rapportoSelezionato) === null || _g === void 0 ? void 0 : _g.carta) === null || _h === void 0 ? void 0 : _h.pan,
                idPeriodo: nexiForm.periodo,
                dataIniziale: moment(nexiForm.dataDa).toDate(),
                dataFinale: moment(nexiForm.dataA).toDate(),
                divisa: "EUR",
                importoDa: (0, helpers_1.formattedNumberToNumber)(nexiForm.importo) * IMPORTO_MOLTIPLICATORI_INTERVALLO.MIN || undefined,
                importoA: (0, helpers_1.formattedNumberToNumber)(nexiForm.importo) * IMPORTO_MOLTIPLICATORI_INTERVALLO.MAX || undefined,
                ordinamento: api_rest_1.MovimentiCartaRequestDtoOrdinamentoEnum.D,
                offset: undefined,
                keyword: undefined
            }
        };
        extraArguments.getItem('jwt').then((jwt) => {
            new api_rest_1.NexiControllerApi((0, general_configuration_1.default)(api_rest_1.Configuration, extraArguments, undefined, jwt, 'application/vnd.ms-excel')).elencoMovimentiNexiExcel(elencoMovimentiNexiExcelRequest).then((response) => {
                if (extraArguments.platform === 'desktop') {
                    (0, helpers_1.hadleExcelResponse)(response, 'movimentiCarta.xlsx');
                }
                if (extraArguments.platform === 'mobile') {
                    (0, helpers_1.download_shareXLS)(extraArguments, 'movimentiCarta.xls', response);
                }
                dispatch(esportaNexiExcelSuccess(response));
            }).catch(async (error) => {
                dispatch(generalError(await (0, helpers_1.formatError)(error)));
            }).finally(() => {
                dispatch((0, general_actions_1.setLoader)(false));
            });
        });
    }
};
exports.esportaMovimentiNexiExcel = esportaMovimentiNexiExcel;
function resetFiltriNexi() {
    return {
        type: __1.EReduxActionTypes.NEXI_RESET_FILTRO
    };
}
exports.resetFiltriNexi = resetFiltriNexi;
function resetNexi() {
    return {
        type: __1.EReduxActionTypes.NEXI_RESET
    };
}
exports.resetNexi = resetNexi;
// PIN VIEW NEXI CREDIT
//START START PIN VIEW SCA
function startPinViewScaStartNexiCredit() {
    return {
        type: __1.EReduxActionTypes.NEXI_START_PIN_VIEW_SCA_START
    };
}
;
function startPinViewScaSuccessNexiCredit(payload) {
    return {
        type: __1.EReduxActionTypes.NEXI_START_PIN_VIEW_SCA_SUCCESS,
        payload
    };
}
;
const startPinViewScaNexiCredit = (cartaNexiId) => (dispatch, getState, extraArguments) => {
    dispatch((0, general_actions_1.setLoader)(true));
    dispatch(startPinViewScaStartNexiCredit());
    if (extraArguments.mock) {
        dispatch((0, general_actions_1.setLoader)(false));
    }
    else {
        const startPinViewSCARequest = {
            startPinViewSCARequestDto: {
                id: cartaNexiId
            }
        };
        extraArguments.getItem('jwt').then((jwt) => {
            new api_rest_1.NexiControllerApi((0, general_configuration_1.default)(api_rest_1.Configuration, extraArguments, undefined, jwt))
                .startPinViewSCANexiCredit(startPinViewSCARequest)
                .then(async (response) => {
                extraArguments.sendEventToMatomo('PIN_VIEW_NEXI_CREDIT', 'GET_PIN_VIEW_SUCCESS_NEXI_CREDIT');
                dispatch(startPinViewScaSuccessNexiCredit(response));
            }).catch(async (error) => {
                extraArguments.sendEventToMatomo('PIN_VIEW_NEXI_CREDIT', `GET_PIN_VIEW_ERROR_NEXI_CREDIT ${error.message}`);
                try {
                    dispatch(generalError(await (0, helpers_1.formatError)(error)));
                }
                catch (e) {
                    console.log(e);
                }
            }).finally(() => {
                dispatch((0, general_actions_1.setLoader)(false));
            });
        });
    }
};
exports.startPinViewScaNexiCredit = startPinViewScaNexiCredit;
//END START PIN VIEW SCA
//START GET PIN VIEW
function getPinViewStartNexiCredit() {
    return {
        type: __1.EReduxActionTypes.NEXI_GET_PIN_VIEW_SCA_START
    };
}
;
function getPinViewSuccessNexiCredit(payload) {
    return {
        type: __1.EReduxActionTypes.NEXI_GET_PIN_VIEW_SCA_SUCCESS,
        payload
    };
}
;
const getPinViewNexiCredit = () => (dispatch, getState, extraArguments) => {
    var _a, _b;
    dispatch((0, general_actions_1.setLoader)(true));
    dispatch(getPinViewStartNexiCredit());
    if (extraArguments.mock) {
        dispatch(getPinViewSuccessNexiCredit({ "content": "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", "contentType": "image/svg+xml" }));
        dispatch((0, general_actions_1.setLoader)(false));
    }
    else {
        const state = getState().nexi;
        if (!((_a = state.startPinViewResponse) === null || _a === void 0 ? void 0 : _a.txId)) {
            return;
        }
        const getPinViewRequest = {
            txId: (_b = state.startPinViewResponse) === null || _b === void 0 ? void 0 : _b.txId
        };
        extraArguments.getItem('jwt').then((jwt) => {
            new api_rest_1.NexiControllerApi((0, general_configuration_1.default)(api_rest_1.Configuration, extraArguments, undefined, jwt))
                .getPinViewNexiCredit(getPinViewRequest)
                .then(async (response) => {
                dispatch(getPinViewSuccessNexiCredit(response));
            }).catch(async (error) => {
                try {
                    dispatch(generalError(await (0, helpers_1.formatError)(error)));
                }
                catch (e) {
                    console.log(e);
                }
            }).finally(() => {
                dispatch((0, general_actions_1.setLoader)(false));
            });
        });
    }
};
exports.getPinViewNexiCredit = getPinViewNexiCredit;
//END GET PIN VIEW
function resetPinViewNexiCredit() {
    return {
        type: __1.EReduxActionTypes.NEXI_RESET_PIN_VIEW
    };
}
exports.resetPinViewNexiCredit = resetPinViewNexiCredit;
;
//PAN VIEW CARTA CONTO
function startPanViewScaStartNexi() {
    return {
        type: __1.EReduxActionTypes.NEXI_START_PAN_VIEW__SCA_START,
    };
}
function startPanViewScaSuccessNexi(payload) {
    return {
        type: __1.EReduxActionTypes.NEXI_START_PAN_VIEW__SCA_SUCCESS,
        payload,
    };
}
const startPanViewScaNexi = (cartaNexiId) => (dispatch, getState, extraArguments) => {
    dispatch((0, general_actions_1.setLoader)(true));
    dispatch(startPanViewScaStartNexi());
    if (extraArguments.mock) {
        dispatch((0, general_actions_1.setLoader)(false));
    }
    else {
        const startPinViewSCARequest = {
            startPanViewSCARequestDto: {
                id: cartaNexiId,
            },
        };
        extraArguments.getItem("jwt").then((jwt) => {
            new api_rest_1.NexiControllerApi((0, general_configuration_1.default)(api_rest_1.Configuration, extraArguments, undefined, jwt))
                .startPanViewSCANexiCredit(startPinViewSCARequest)
                .then(async (response) => {
                extraArguments.sendEventToMatomo('PAN_VIEW_NEXI_CREDIT', 'GET_PAN_VIEW_SUCCESS_NEXI_CREDIT');
                dispatch(startPanViewScaSuccessNexi(response));
            })
                .catch(async (error) => {
                extraArguments.sendEventToMatomo('PAN_VIEW_NEXI_CREDIT', `GET_PAN_VIEW_ERROR_NEXI_CREDIT ${error.message}`);
                try {
                    dispatch(generalError(await (0, helpers_1.formatError)(error)));
                }
                catch (e) {
                    console.log(e);
                }
            })
                .finally(() => {
                dispatch((0, general_actions_1.setLoader)(false));
            });
        });
    }
};
exports.startPanViewScaNexi = startPanViewScaNexi;
//START GET PAN VIEW
function getPanViewStartNexi() {
    return {
        type: __1.EReduxActionTypes.NEXI_GET_PAN_VIEW_START,
    };
}
function getPanViewSuccessNexi(payload) {
    return {
        type: __1.EReduxActionTypes.NEXI_GET_PAN_VIEW_SUCCESS,
        payload,
    };
}
const getPanViewNexi = () => (dispatch, getState, extraArguments) => {
    var _a, _b;
    dispatch((0, general_actions_1.setLoader)(true));
    dispatch(getPanViewStartNexi());
    if (extraArguments.mock) {
        dispatch(getPanViewSuccessNexi({
            content: "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",
            contentType: "image/svg+xml",
        }));
        dispatch((0, general_actions_1.setLoader)(false));
    }
    else {
        const nexi = getState().nexi;
        if (!((_a = nexi.startPanViewResponse) === null || _a === void 0 ? void 0 : _a.txId)) {
            return;
        }
        const getPinViewRequest = {
            txId: (_b = nexi.startPanViewResponse) === null || _b === void 0 ? void 0 : _b.txId,
        };
        extraArguments.getItem("jwt").then((jwt) => {
            new api_rest_1.NexiControllerApi((0, general_configuration_1.default)(api_rest_1.Configuration, extraArguments, undefined, jwt))
                .getPanViewNexiCredit(getPinViewRequest)
                .then(async (response) => {
                dispatch(getPanViewSuccessNexi(response));
            })
                .catch(async (error) => {
                try {
                    dispatch(generalError(await (0, helpers_1.formatError)(error)));
                }
                catch (e) {
                    console.log(e);
                }
            })
                .finally(() => {
                dispatch((0, general_actions_1.setLoader)(false));
            });
        });
    }
};
exports.getPanViewNexi = getPanViewNexi;
//END GET PAN VIEW
//COPY PAN VIEW
function copyPanViewNexiSuccess(payload) {
    return {
        type: __1.EReduxActionTypes.NEXI_COPY_PAN_VIEW,
        payload,
    };
}
exports.copyPanViewNexiSuccess = copyPanViewNexiSuccess;
const copyPanViewNexi = () => (dispatch, getState, extraArguments) => {
    var _a, _b, _c;
    dispatch((0, general_actions_1.setLoader)(true));
    const nexi = getState().nexi;
    if (!((_a = nexi.startPanViewResponse) === null || _a === void 0 ? void 0 : _a.txId)) {
        dispatch((0, general_actions_1.setLoader)(false));
        return;
    }
    const getPinViewRequest = {
        body: (_c = (_b = nexi.getPanViewResponse) === null || _b === void 0 ? void 0 : _b.content) !== null && _c !== void 0 ? _c : ''
    };
    extraArguments.getItem("jwt").then((jwt) => {
        new api_rest_1.NexiControllerApi((0, general_configuration_1.default)(api_rest_1.Configuration, extraArguments, undefined, jwt))
            .getEncryptedNexiPanView(getPinViewRequest)
            .then(async (response) => {
            dispatch(copyPanViewNexiSuccess(response));
        })
            .catch(async (error) => {
            try {
                dispatch(generalError(await (0, helpers_1.formatError)(error)));
            }
            catch (e) {
                console.log(e);
            }
        })
            .finally(() => {
            dispatch((0, general_actions_1.setLoader)(false));
        });
    });
};
exports.copyPanViewNexi = copyPanViewNexi;
function resetPanViewNexi() {
    return {
        type: __1.EReduxActionTypes.NEXI_RESET_PAN_VIEW,
    };
}
exports.resetPanViewNexi = resetPanViewNexi;
